import React from 'react'

import Layout from '../shared/components/organisms/layout/layout'
import SEO from '../shared/components/seo'
import NotFoundContent from '../components/molecules/notFoundContent/notFoundContent'
import useMobileMode from '../shared/hooks/useMobileMode'

const NotFoundPage = () => {
	const { isMobile } = useMobileMode()
	return (
		<Layout title='404: Not found' isMobile={isMobile}>
			<SEO title='404: Not found' />
			<NotFoundContent />
		</Layout>
	)
}

export default NotFoundPage
